<template>
  <a href="#main" class="skip-to-main">Skip to main content</a>
  <div
    v-cloak
    v-if="brandSlug === 'BH1'"
    class="header-wrapper-bhx"
    :style="set_style_variables"
  >
    <div class="header-inner" :class="page_classes">
      <div
        @click="gotoPage(logo_link.url, logo_link.mtype)"
        class="ID-logo"
      ></div>
      <div>
        <div class="bhx-links">
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/arrivals-and-departures/"
            ><i class="icon icon--arrivals-departures"></i>Arrivals and
            Departures</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/airport-parking/"
            ><i class="icon icon--parking"></i>Parking</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/directions-and-transport/"
            ><i class="icon icon--directions-transport"></i>Directions and
            Transport</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/at-the-airport/"
            ><i class="icon icon--airport"></i>At the Airport</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/destinations-and-more/"
            ><i class="icon icon--destintinations-and-more"></i>Destinations
            &amp; More</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/at-the-airport/terminal-facilities/assisted-travel/"
            ><i class="icon icon--special-assistance"></i>Assisted Travel</a
          >
          <a
            target="_blank"
            href="https://www.birminghamairport.co.uk/search/"
            class="bhx-search"
            ><i class="icon icon--search"></i>Search</a
          >
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    v-cloak
    v-if="brandSlug === 'LAX'"
    class="header-wrapper header-wrapper-hello-msg"
    :style="set_style_variables"
    style="width: 100%"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <span class="hello-msg"
          >We have upgraded our booking platform. Need Help?
          <a
            href="https://parking.flylax.com/lax-newbookingsite.html"
            target="_blank"
            >Click here</a
          ></span
        >
      </div>
    </div>
  </div> -->

  <div
    v-cloak
    v-if="brandSlug === 'RDU'"
    class="header-wrapper header-wrapper-hello-msg header-wrapper-hello-msg-rdu"
    :class="page_classes"
    :style="set_style_variables"
    style="width: 100%"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <span class="hello-msg"
          >A REAL ID or other approved ID is now required to fly.
          <a href="https://www.dhs.gov/real-id" target="_blank"
            >www.dhs.gov/real-id</a
          ></span
        >
      </div>
    </div>
  </div>

  <div v-else-if="brandSlug === 'LAS'">
    <!-- dont show anything for now -->
  </div>

  <div
    v-cloak
    v-else
    class="header-wrapper header-wrapper-hello-msg header-wrapper-hello-msg-all"
    :class="page_classes"
    :style="set_style_variables"
    style="width: 100%"
  >
    <div class="header-inner">
      <div class="menu-items-wrapper">
        <strong class="hello-msg"
          >YOU HAVE REACHED A TEST SITE - PLEASE DO NOT ATTEMPT TO BOOK OR MAKE
          PAYMENT</strong
        >
      </div>
    </div>
  </div>

  <div
    class="header-wrapper"
    @mouseleave="leaveUserPanel()"
    :class="[
      manage_header_no_toggle ? ` manage-header-perm` : ``,
      page_classes,
    ]"
    :style="set_style_variables"
  >
    <div class="header-inner">
      <div
        class="ID-logo"
        :class="`ID-logo-${brandSlug}`"
      >
        <a
          :href="logo_link.url"
          class="ID-logo-link"
          :tabindex="brandSlug === 'BH1' ? -1 : null"
          @click.prevent="gotoPage(logo_link.url, logo_link.mtype)"
        >
          <img
            v-if="logo_image"
            :src="logo_image"
            :alt="brandSlug + ' home'"
            class="ID-logo-img"
          />
        </a>
      </div>
      <div class="menu-items-wrapper">
        <a
          v-if="show_home"
          :href="home_link || '/'"
          @click.prevent="gotoPage(home_link)"
          :class="`menu-item tab-home${
            highlight_tab_item === 1 || highlight_tab_item === '/'
              ? ' tab-active'
              : ''
          }`"
          aria-label="Home"
        >
          <i class="fa fa-home" aria-hidden="true"></i>
        </a>

        <template v-for="(item, index) in header_menu" :key="index">
          <a
            v-if="logged_in && item.loggedin && item.label"
            :href="item.url"
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
            @click.prevent="gotoPage(item.url, item.mtype)"
          >
            {{ getrans(item.label) }}
          </a>
          <div
            v-if="
              !logged_in &&
              item.loggedout &&
              item.label &&
              item.label.toLowerCase() == 'login'
            "
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
          >
            {{ getrans(item.label) }}
          </div>
          <a
            v-if="
              !logged_in &&
              item.loggedout &&
              item.label &&
              item.label.toLowerCase() != 'login'
            "
            :href="item.url"
            :class="`menu-item menu-item-loop tab-${index + 1}${
              item.label === highlight_tab_item ? ' tab-active' : ''
            }`"
            @click.prevent="gotoPage(item.url, item.mtype)"
          >
            {{ getrans(item.label) }}
          </a>
        </template>

        <div
          v-if="show_languages"
          class="menu-item menu-item-dropdown-lang tab-lang"
        >
          <button
            type="button"
            class="lang-toggle"
            :aria-expanded="show_language_dropdown"
            aria-haspopup="true"
            :aria-label="getrans('Select language')"
            @click="show_language_dropdown = !show_language_dropdown"
          >
            <span class="lang-text">{{ lang }}</span>
            <div
              class="lang-flag"
              :style="flagImage(brandSlug === 'PIT' ? 'us' : lang)"
            ></div>
          </button>

          <transition name="fade">
            <div
              v-show="show_language_dropdown"
              class="menu-item-dropdown-lang__select"
            >
              <button
                v-for="lng in languages"
                :key="lng"
                type="button"
                class="menu-item-dropdown-lang__select-item"
                @click="changeLang(lng)"
              >
                <div :class="`lang-flag ${lng}`" :style="flagImage(lng)"></div>
                <span>{{ lng.toUpperCase() }}</span>
              </button>
            </div>
          </transition>
        </div>

        <!-- @click="gotoPage('/yourdetails.html')" -->
        <div
          v-if="new_basket_number > 0 && basket_is_model_and_page"
          :class="basket_is_model_and_page"
          class="menu-item tab-basket basket_is_model_and_page_desktop"
          tabindex="0"
          @click="gotoPage('/yourdetails.html')"
        >
          <BasketIcon :basket_number="new_basket_number" />
          <span class="basket-text">Basket</span>
        </div>

        <div
          v-if="new_basket_number > 0 && basket_is_model_and_page"
          :class="basket_is_model_and_page"
          class="menu-item tab-basket basket_is_model_and_page_mobile"
          tabindex="0"
          @click="toggle_basket_model()"
        >
          <BasketIcon :basket_number="new_basket_number" />
          <span class="basket-text">Basket</span>
        </div>

        <div
          v-if="new_basket_number > 0 && !basket_is_model_and_page"
          class="menu-item tab-basket"
          tabindex="0"
          @click="
            basket_is_model
              ? toggle_basket_model()
              : gotoPage('/yourdetails.html')
          "
        >
          <BasketIcon :basket_number="new_basket_number" />
          <span class="basket-text">Basket</span>
        </div>

        <div
          v-if="show_user_is_logged_in && initials && initials !== 'UU'"
          :class="`${manage_header ? `manage-header-show` : ``}`"
          class="user-panel"
        >
          <div class="user-panel-new">
            <div class="user-initials">{{ initials }}</div>
            <span class="user-fullname"
              >{{ firstname }} {{ surname }}&nbsp;&nbsp;</span
            >
          </div>
          <button type="button" class="user-logout" @click="logoutsession">
            <i class="fas fa-sign-out-alt"> </i> {{ getrans("Logout") }}</button
          >
        </div>

        <div
          v-else-if="new_login_modal() && !hide_signin"
          :class="`menu-item ${manage_header ? `manage-header-show` : ``}`"
          class="user-panel"
        >
          <button
            type="button"
            id="sign-in-trigger"
            class="user-login"
            @click="loginsession"
            ><i class="fas fa-user-circle"></i> {{ getrans("Sign in") }}</button
          >
        </div>

        <div
          v-if="header_menu.length"
          class="menu-item tab-mobile-menu"
          @click="showMobileMenu = !showMobileMenu"
          @focusout="showMobileMenu = false"
          tabindex="0"
        >
          <i class="fa fa-bars"></i>
          <transition name="fade">
            <div v-show="showMobileMenu" class="menu-items_mobile-wrapper">
              <a
                href="/index.html"
                :class="`menu-item-mobile tab-0`"
                @click.prevent="gotoPage('/index.html')"
              >
                <span>{{ getrans("Home") }}</span
                ><i class="fa fa-chevron-right"></i>
              </a>

              <template v-for="(item, index) in header_menu" :key="index">
                <a
                  v-if="logged_in && item.loggedin && item.label"
                  :href="item.url"
                  :class="`menu-item-mobile tab-${index + 1}`"
                  @click.prevent="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </a>

                <a
                  v-if="!logged_in && item.loggedout && item.label"
                  :href="item.url"
                  :class="`menu-item-mobile tab-${index + 1}`"
                  @click.prevent="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </a>
              </template>

              <template v-for="(item, index) in manage_menu" :key="index">
                <a
                  v-if="logged_in && item.label"
                  :href="item.url"
                  :class="`menu-item-mobile tab-${index + 1}-2`"
                  @click.prevent="gotoPage(item.url, item.mtype)"
                >
                  <span>{{ getrans(item.label) }}</span
                  ><i class="fa fa-chevron-right"></i>
                </a>
              </template>

              <button
                v-if="show_user_is_logged_in"
                type="button"
                @click="logoutsession"
                :class="`menu-item-mobile tab-logout`"
              >
                <span>{{ getrans("Logout") }}</span
                ><i class="fas fa-sign-out-alt"></i>
              </button>

              <button
                v-else-if="new_login_modal() && !hide_signin"
                type="button"
                @click="loginsession"
                :class="`menu-item-mobile tab-logout`"
              >
                <span>{{ getrans("Sign In") }}</span
                ><i class="fas fa-sign-out-alt"></i>
              </button>

              <div class="menu-item-mobile tab-lang" v-if="show_languages">
                <div v-for="lng in languages" :key="lng">
                  <div
                    :class="`lang-flag ${lng}`"
                    :style="flagImage(lng)"
                    @click="changeLang(lng)"
                  ></div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div
      v-if="logged_in"
      :class="`manage-header${manage_header ? ` manage-header-show` : ``}`"
    >
      <div class="manage-header-inner">
        <a
          v-for="(item, index) in manage_menu"
          :key="index"
          :href="item.url"
          :class="`${item.active === manage_active ? 'active' : ''}`"
          >{{ item.text }}</a
        >
        <a v-if="logged_in" @click="logged_in = !logged_in">{{
          getrans("Logout")
        }}</a>
      </div>
    </div>
  </div>

  <div
    class="header-message-wrapper"
    v-if="
    popup_messages_api_data && 
    popup_messages_api_data.status === 'Active' &&
    popup_messages_api_data.bar_published === 1 &&
    !popup_bar_dismissed
    "
  >
    <div class="header-message-inner">
      <div>
        <i
          v-if="popup_messages_api_data.bar_title"
          :class="[
            'fa',
            getPopupIconClass(popup_messages_api_data.icon_type),
            'header-message-info-icon',
            `header-message-info-icon--${getPopupIconType(
              popup_messages_api_data.icon_type
            )}`,
          ]"
          aria-hidden="true"
        ></i>
        <b v-if="popup_messages_api_data.bar_title"
          >{{ popup_messages_api_data.bar_title }}:</b
        >&nbsp;
        <span v-if="popup_messages_api_data.bar_message"
          >{{ popup_messages_api_data.bar_message }}&nbsp;</span
        >
      </div>
      <div>
        <button
          v-if="popup_messages_api_data.bar_button_text"
          class="header-message-button"
          @click="getPopupMessages_info_popup($event)"
        >
          {{ popup_messages_api_data.bar_button_text }}
        </button>
        <button
          v-if="popup_messages_api_data.bar_closable === 1"
          class="header-message-close"
          type="button"
          aria-label="Close message"
          @click="closePopupMessageBar()"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <!-- {{ popup_messages_api_data }} -->
    </div>
  </div>

  <Dialog
    header="Please enter your email id to proceed"
    v-model:visible="dialog"
    :style="{ width: '50vw' }"
  >
    <div class="block">
      <label for="emailid">
        {{ "Enter your email address" }}
        <span class="form-mandatory">*</span>
      </label>
      <input
        name="emailid"
        autofocus="autofocus"
        type="text"
        id="emailid"
        data-lpignore="true"
      />
    </div>
    <template #footer>
      <button @click="closeBasic">{{ "Close" }}</button>
      <button @click="closeBasic" autofocus>{{ "Proceed" }}</button>
    </template>
  </Dialog>
  <!-- <WebChatBotNew v-if="!disable_chat_panel && brandSlug === 'AIR'" :brandSlug="brandSlug" />
  <WebChatBot v-else-if="!disable_chat_panel" :brandSlug="brandSlug" /> -->
  <template v-if="new_login_modal()">
    <LoginModelNew :getransfn="getrans" :setbrandid="brandSlug" :lang="lang"/>
  </template>
  <rez-ai
    :key="rez_ai_refresh_key"
    :brand-slug="brandSlug"
    v-if="brandSlug === 'AIR' || brandSlug === 'NOC'"
    :email-prop="email"
    :full-name="`${firstname} ${surname}`"
    :first-name="firstname"
  ></rez-ai>
</template>

<script>
import BasketIcon from "@/components/BasketIcon.vue";
import md5 from "js-md5";
import LoginModelNew from "@/components/LoginModelNew.vue";
//import WebChatBot from "@/components/webChatBot.vue";
//import WebChatBotNew from "@/components/webChatBot_new.vue";

const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

const axios = require("axios");
import Swal from "sweetalert2";

export default {
  name: "Header",
  props: {
    disable_chat_panel: undefined,
    basket_is_model: undefined,
    basket_is_model_and_page: undefined,
    logo_link: undefined,
    home_link: undefined,
    show_home: undefined,
    show_languages: undefined,
    basket_number: undefined,
    manage_header_no_toggle: undefined,
    manage_active: undefined,
    userfirstname: undefined,
    logo_image: undefined,
    header_menu: undefined,
    show_basket: undefined,
    lang: undefined,
    translations: undefined,
    brandSlug: undefined,
    highlight_tab_item: undefined,
    page_classes: undefined,
    hide_signin: undefined,
    popup_page: undefined,
  },
  components: {
    BasketIcon,
    LoginModelNew,
    //WebChatBot,
    //WebChatBotNew
  },
  emits: ["toggleBasket"],
  data() {
    return {
      rez_ai_refresh_key: 0,
      show_user_is_logged_in: false,
      new_basket_number: 0,
      show_language_dropdown: false,
      logged_in: false,
      dialog: false,
      manage_header: false,
      showMobileMenu: false,
      showBasket: false,
      showBasketOnHeader: true,
      header_items_data: [
        { url: "/faqs.html", text: "FAQs", loggedin: true, loggedout: true },
        {
          url: "https://myaccount.rezcommdev.com",
          loggedin: true,
          loggedout: true,
          class: "",
          label: "Home",
          mcolumn: "No Columns",
          menusvg: "",
          mgroup: "",
          mid: 149,
          mtype: "Internal",
          position: "T",
        },
      ],
      manage_menu: [
        { url: "/bookings.html", text: "Your Bookings", active: "bookings" },
        { url: "/details.html", text: "Your Details", active: "details" },
        {
          url: "/changepassword.html",
          text: "Change Password",
          active: "changepassword",
        },
      ],
      languages: ["el", "en"],
      firstname: "",
      surname: "",
      initials: "",
      adhoc_cart: undefined,
      popup_messages_dialog: false,
      popup_messages_api_data: undefined,
      popup_bar_dismissed: false,
    };
  },
  computed: {
    set_style_variables: function () {
      return {
        "--logo-image": `url(${this.logo_image})`,
      };
    },
  },
  methods: {
    new_login_modal() {
      if (
        process.env.VUE_APP_NEW_LOGIN_MODAL &&
        JSON.parse(process.env.VUE_APP_NEW_LOGIN_MODAL).includes(this.brandSlug)
      ) {
        return true;
      }
      return false;
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.brandSlug + "-" + this.lang.toUpperCase() + "-" + s;
      console.log(ss);
      return this.translations[ss] || string;
    },
    changeLang(lang) {
      store.setItem("tranlations", null);
      this.setSessionData("language", lang);
      const url = new URL(window.location.href);
      var search_params = url.searchParams;
      search_params.set("lang", lang);
      url.search = search_params.toString();
      var new_url = url.toString();
      window.location = new_url;
    },
    flagImage(lang) {
      return `background-image: url(${require(`../assets/flags/` +
        lang.toUpperCase() +
        `.png`)});`;
    },

    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },

    openBasic() {
      this.dialog = true;
    },
    closeBasic() {
      this.dialog = false;
    },
    toggleBasket() {
      this.$emit("toggleBasket");
    },
    toggle_basket_model() {
      const new_event = new CustomEvent("basket_model_toggle", {
        detail: {
          data: "toggle",
        },
      });
      window.dispatchEvent(new_event);
    },
    gotoPage(url, type = null) {
      let logKey;
      let mmb_link = encryptStorage.getItem("mmb_link");

      if (mmb_link && url.indexOf(mmb_link) > -1) {
        console.log("enw_log_key", logKey);
        logKey = encryptStorage.getItem("enw_log_key");
      }

      // Append mmb_link as a query parameter
      if (logKey) {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set("log_key", logKey);
        url = urlObj.toString();
      }

      // Append lang if needed
      if (
        (url.indexOf("myaccountdev.") > -1 ||
          url.indexOf("myaccount.") > -1 ||
          url.indexOf("managemyaccountdev.") > -1) &&
        this.lang
      ) {
        const urlObj = new URL(url);
        urlObj.searchParams.set("lang", this.lang);
        url = urlObj.toString();
      }

      // Redirect or open in new tab
      if (type && type.toLowerCase() === "external") {
        window.open(url);
      } else {
        window.location.href = url;
      }
    },
    enterUserPanel() {
      if (!this.manage_header_no_toggle) {
        this.manage_header = true;
      }
    },
    leaveUserPanel() {
      if (!this.manage_header_no_toggle) {
        this.manage_header = false;
      }
    },
    toggleUserPanel() {
      if (!this.manage_header_no_toggle) {
        this.manage_header = !this.manage_header;
      }
    },

    check_for_session() {
      //checks for session
      if (sessionStorage.getItem("session_uuid") === null) {
        //do nothing
        this.show_user_is_logged_in = false;
      } else {
        let userdata = encryptStorage.getItem("session_userdata");
        if (userdata && userdata !== "undefined") {
          this.show_user_is_logged_in = true;
          this.firstname = decodeURI(userdata.first_name);
          this.surname = decodeURI(userdata.last_name);
          let initial_1 = Array.from(this.firstname)[0];
          let initial_2 = Array.from(this.surname)[0];
          this.initials = initial_1 + initial_2;
          this.initials = this.initials.toUpperCase();
        }
      }
    },
    loginsession() {
      const new_event = new CustomEvent("loginModel", {
        detail: {
          data: {},
        },
      });
      window.dispatchEvent(new_event);
    },
    async logoutsession() {
      // Clear remember device first
      try {
        const RememberDevice = (await import("@/modules/RememberDevice"))
          .default;
        console.log("forgetDevice remember device:", "starting");
        RememberDevice.forgetDevice();
      } catch (e) {
        console.log("Error clearing remember device:", e);
      }

      // Clear all session and local storage
      sessionStorage.clear();
      localStorage.clear();

      // Clear encrypted storage
      encryptStorage.clear();

      // Clear specific cookies related to authentication and device memory
      const cookiesToClear = [
        "guid_token",
        "session_uuid",
        "rememberdevice",
        "remember_device",
        "device_token",
        "auth_token",
        "access_token",
        "refresh_token",
        "user_session",
        "login_token",
        "utm_partner",
        "utm_medium",
        "utm_source",
        "utm_campaign",
      ];

      // Clear cookies for current domain and all possible paths
      cookiesToClear.forEach((cookieName) => {
        // Clear for current path
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        // Clear for root path
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
        // Clear for subdomain
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
      });

      // Use cookie utility if available
      if (this.$cookie && this.$cookie.deleteCookie) {
        cookiesToClear.forEach((cookieName) => {
          this.$cookie.deleteCookie(cookieName);
        });
      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      //window.location.reload();
    },
    setBasketNumber() {
      this.new_basket_number = 0;
      if (sessionStorage.getItem("cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("fasttrack_cart")) {
        let fasttrack_cart = encryptStorage.getItem("fasttrack_cart");
        if (Array.isArray(fasttrack_cart)) {
          this.new_basket_number += fasttrack_cart.length;
        } else {
          this.new_basket_number++;
        }
      }
      if (sessionStorage.getItem("lounge_cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("coach_cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("atr_cart")) {
        this.new_basket_number++;
      }
      if (sessionStorage.getItem("adhoc_cart")) {
        let adhoc_cart = encryptStorage.getItem("adhoc_cart");
        if (typeof adhoc_cart !== "undefined") {
          console.log("adhoc_cart_tt", adhoc_cart);
          for (let index = 0; index < adhoc_cart.length; index++) {
            if (Array.isArray(adhoc_cart[index])) {
              adhoc_cart[index].map((item) => {
                if (item.pr_price) {
                  this.new_basket_number++;
                }
              });
            } else {
              if (adhoc_cart[index] !== null) {
                if (adhoc_cart[index] && adhoc_cart[index].pr_price) {
                  this.new_basket_number++;
                }
              }
            }
          }
        }
      }
      if (sessionStorage.getItem("adhoc_lounge_cart")) {
        let adhoc_lounge_cart = encryptStorage.getItem("adhoc_lounge_cart");
        /* eslint-disable */
        for (const key in adhoc_lounge_cart) {
          if (adhoc_lounge_cart.hasOwnProperty(key)) {
            for (const item in adhoc_lounge_cart[key]) {
              this.new_basket_number++;
            }
          }
        }
        /* eslint-enable */
      }
    },
    refreshBasketCount() {
      this.setBasketNumber();
    },

    set_langs() {
      if (this.brandSlug === "AIR") {
        this.languages = ["en", "el", "es", "de", "fr", "pt"];
        console.log(this.brandSlug, this.languages);
      }
      if (this.brandSlug === "SZG") {
        this.languages = ["de", "en"];
        //console.log(this.brandSlug, this.languages);
      }
      if (this.brandSlug === "FM1") {
        this.languages = ["de", "en"];
      }
      if (this.brandSlug === "FMM") {
        this.languages = ["de", "en"];
      }
      if (this.brandSlug === "BRE") {
        this.languages = ["de", "en"];
      }
      if (this.brandSlug === "PB1") {
        this.languages = ["de", "en"];
      }
      if (this.brandSlug === "PIT") {
        this.languages = ["us", "es"];
      }
      if (this.brandSlug === "NUE") {
        this.languages = ["de", "en"];
      }
      if (this.brandSlug === "RUN") {
        this.languages = ["fr", "en"];
      }
     
    },

    getPopupMessages() {
      let brand = this.brandSlug;
      axios
        .post(
          `https://devapi.rezcomm.com/dev/popup/frontend/view`,
          {
            brand_id: brand,
            page: this.popup_page,
          },
          {
            headers: {
              secret_id: `nocpopup_frontend_view_secret_id`,
              secret_key: `nocpopup_frontend_view_secret_key`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.popup_messages_api_data = response.data.data || null;
          this.popup_bar_dismissed = false;
          console.log(this.popup_messages_api_data);
        });
    },

    closePopupMessageBar() {
      this.popup_bar_dismissed = true;
    },

    getPopupIconType(iconType) {
      const normalizedType = (iconType || "information").toString().toLowerCase();
      if (
        normalizedType === "information" ||
        normalizedType === "alert" ||
        normalizedType === "weather_warning"
      ) {
        return normalizedType;
      }
      return "information";
    },

    getPopupIconClass(iconType) {
      const normalizedType = this.getPopupIconType(iconType);
      if (normalizedType === "alert") {
        return "fa-exclamation-triangle";
      }
      if (normalizedType === "weather_warning") {
        return "fa-snowflake";
      }
      return "fa-info-circle";
    },

    getPopupMessages_info_popup($event) {
      const triggerEl = $event?.currentTarget || document.activeElement;
      const popupData = this.popup_messages_api_data || {};

      if (popupData.popup_published !== 1 ) {
        return false; // Exit if the popup is not published
      }

      const popupTitle = popupData["popup_title"]
        ? this.getrans(popupData["popup_title"])
        : this.getrans("Information");
      const popupMessage = popupData["popup_message"]
        ? this.getrans(popupData["popup_message"])
        : "";
      const popupButtonTextRaw = String(popupData["popup_button_text"] || "").trim();
      const popupButtonText = popupButtonTextRaw
        ? this.getrans(popupButtonTextRaw)
        : this.getrans("OK");
      const popupIconType = this.getPopupIconType(popupData["icon_type"]);
      const popupIconClass = this.getPopupIconClass(popupData["icon_type"]);

      const isClosable =
        popupData["popup_closable"] === 1 ||
        popupData["popup_closable"] === "1" ||
        popupData["popup_closable"] === true;

      const popupLinkFields = [
        popupData["popup_button_link"],
        popupData["popup_link"],
        popupData["popup_url"],
        popupData["button_url"],
        popupData["popup_link_url"],
      ];
      const rawPopupLink = popupLinkFields.find((value) => String(value || "").trim() !== "") || "";

      let popupLink = "";
      if (rawPopupLink) {
        try {
          const parsed = new URL(String(rawPopupLink).trim(), window.location.origin);
          if (parsed.protocol === "http:" || parsed.protocol === "https:") {
            popupLink = parsed.toString();
          }
        } catch (e) {
          console.log("Invalid popup link:", rawPopupLink, e);
        }
      }

      Swal.fire({
        title: popupTitle,
        text: popupMessage,
        icon: "info",
        iconHtml: `<i class="fa ${popupIconClass}" aria-hidden="true"></i>`,
        confirmButtonText: popupButtonText,
        showCloseButton: isClosable,
        allowOutsideClick: isClosable,
        allowEscapeKey: isClosable,
        customClass: {
          popup: "header-swal-popup",
          title: "header-swal-title",
          htmlContainer: "header-swal-content",
          closeButton: "header-swal-close",
          actions: "my-actions",
          icon: `header-swal-icon header-swal-icon--${popupIconType}`,
          confirmButton: "order-2",
          denyButton: "order-3",
        },
        didClose: () => {
          if (triggerEl && triggerEl.isConnected) {
            triggerEl.focus();
          }
        },
      }).then((result) => {
        if (result.isConfirmed && popupLink) {
          window.open(popupLink, "_blank", "noopener,noreferrer");
        }
      });
    },

  },
  mounted() {
    // WCAG 2.4.1 skip link must only appear when the user explicitly Tabs to
    // it. Browsers can restore focus to it after a reload/HMR (making it
    // visible on page load) — blur it in that case.
    if (
      document.activeElement &&
      document.activeElement.classList &&
      document.activeElement.classList.contains("skip-to-main")
    ) {
      document.activeElement.blur();
    }
    this.check_for_session();
    if (this.manage_header_no_toggle) {
      this.manage_header = true;
    }
    if (typeof this.userfirstname === "undefined") {
      this.logged_in = false;
    } else {
      this.logged_in = false;
    }

    this.refreshBasketCount();
    this.set_langs();

    window.addEventListener(
      "update_basket",
      () => {
        this.refreshBasketCount();
      },
      false
    );
    window.addEventListener(
      "userLoggedIn",
      () => {
        this.check_for_session();
      },
      false
    );

    this.rez_ai_refresh_key++;
  },
  updated() {
    this.set_langs();
    //this.getPopupMessages();
    if (!this.popup_messages_api_data) {
      this.getPopupMessages();
    }
  },
};
</script>


<style lang="scss">
@import "@/assets/sass/swalOverride.scss";

.swal2-popup.header-swal-popup {
  max-width: 370px;
  width: calc(100% - 3rem);
  padding: 2rem 1.5rem 2rem;
  border-radius: 0;
}

.swal2-popup.header-swal-popup .swal2-icon.header-swal-icon.swal2-info {
  border: 0 !important;
  width: auto;
  height: auto;
  margin: 0 auto 1rem;
  color: #1120f4;
}

.swal2-popup.header-swal-popup
  .swal2-icon.header-swal-icon.header-swal-icon--information.swal2-info {
  color: #1120f4;
}

.swal2-popup.header-swal-popup
  .swal2-icon.header-swal-icon.header-swal-icon--alert.swal2-info {
  color: #e30613;
}

.swal2-popup.header-swal-popup
  .swal2-icon.header-swal-icon.header-swal-icon--weather_warning.swal2-info {
  color: #ff9800;
}

.swal2-popup.header-swal-popup .swal2-icon-content {
  font-size: 2.5rem;
  line-height: 1;
}

.swal2-popup.header-swal-popup .swal2-title.header-swal-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f0f0f;
  margin: 0.25rem 0 1.25rem;
}

.swal2-popup.header-swal-popup .swal2-html-container.header-swal-content {
  margin: 0;
  font-size: 1rem;
  line-height: 1.38;
  color: #252525;
  white-space: pre-line;
}

.swal2-popup.header-swal-popup .swal2-close.header-swal-close {
  color: #121212 !important;
  font-size: 2rem;
  font-weight: 700;
  right: 0.25rem;
  top: 0.25rem;
}

.swal2-popup.header-swal-popup .swal2-actions.my-actions {
  width: 100%;
  margin: 1.5rem 0 0;
  padding: 0;
}

.swal2-popup.header-swal-popup .swal2-actions .swal2-styled.swal2-confirm.order-2 {
  width: 100%;
  min-height: 3rem;
  margin: 0;
  border: 1px solid #567bb1 !important;
  border-radius: 0 !important;
  background: #fff !important;
  color: #365a8f !important;
  font-size: 1rem;
  font-weight: 700;
  box-shadow: none !important;
  padding: 0.75rem 1rem;
}

.swal2-popup.header-swal-popup
  .swal2-actions:not(.swal2-loading)
  .swal2-styled.swal2-confirm.order-2:hover {
  background: #f4f8ff !important;
  border-color: #4a72ac !important;
}

@media screen and (max-width: 640px) {
  .swal2-popup.header-swal-popup {
    padding: 1.25rem 1rem 1.25rem;
  }

  .swal2-popup.header-swal-popup .swal2-title.header-swal-title {
    font-size: 1rem;
  }

  .swal2-popup.header-swal-popup .swal2-html-container.header-swal-content {
    font-size: 0.75rem;
  }

  .swal2-popup.header-swal-popup .swal2-actions .swal2-styled.swal2-confirm.order-2 {
    font-size: 1rem;
  }
}
</style>


<style scoped lang="scss">
[v-cloak] {
  display: none;
}

.skip-to-main {
  position: absolute;
  left: -9999px;
  top: 0;

  &:focus {
    left: 0;
    z-index: 99999999999999;
    background: #fff;
    color: #236ca3;
    padding: 0.75rem 1rem;
    outline: 2px solid #236ca3;
  }
}

@import "@/assets/sass/variables.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.user-panel {
  display: none;
  @media screen and (min-width: 960px) {
    padding: 15px 15px;
    display: flex;
    align-items: center;
    max-height: 56px;
    transition: 0.15s ease-in-out;
    span {
      padding-left: 0.5rem;
      font-weight: bold;
      line-height: 1;
    }
  }
  .user-fullname {
    @media screen and (max-width: 1200px) {
      display: none;
    }
  }

  .user-panel-new {
    background: var(--header_background_color_active, #000);
    color: var(--header_background_color, #fff);
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.333rem;
    .user-initials {
      color: var(--header_background_color_active, #000);
      background: var(--header_background_color, #fff);
      font-weight: bold;
    }
    @media screen and (max-width: 1200px) {
      display: none;
    }
  }

  .user-initials {
    background: var(--header_background_color_active, #000);
    color: var(--header_background_color, #fff);
    width: 2rem;
    height: 2rem;
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-logout {
    background: none;
    border: 0;
    padding: 0;
    font: inherit;
    line-height: 1;
    padding-left: 2rem;
    font-weight: bold;
    cursor: pointer;
    color: var(--header_basket_number_color, #236ca3);
    white-space: nowrap;
  }
  .user-login {
    background: none;
    border: 0;
    padding: 0 0 0 0.5rem;
    font: inherit;
    font-weight: bold;
    line-height: 1;
    color: inherit;
    cursor: pointer;
    white-space: nowrap;
    min-height: 24px;
    display: inline-flex;
    align-items: center;
  }
}

.user-panel.manage-header-show {
  background: $header-user-bg-hvr;
  color: $header-user-text-hvr;
}

.manage-header.manage-header-show {
  max-height: 60px;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
}

.manage-header-perm .manage-header {
  &.manage-header-show {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
  }

  .manage-header-inner {
    a {
      align-items: center;
      display: flex;
      position: relative;
      height: 100%;
    }
    a.active:after {
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      content: " ";
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #fff transparent;
    }
  }
}

.manage-header {
  display: none;
  @media screen and (min-width: 960px) {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
    transition: 0.15s ease-in-out;
    max-height: 0px;
    overflow: hidden;
    float: left;
    clear: both;
    margin-top: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    top: 60px;
    left: 0px;
    right: 0px;
    width: 100%;
    z-index: 99999;
    height: 60px;
    background: $header-manage-bg;
    color: $header-manage-text;
    .manage-header-inner {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      max-width: 1280px;
      width: 100%;
      > * {
        padding: 0px 15px;
      }
      a {
        color: $header-manage-text;
        text-decoration-line: none;
      }
    }
  }
}

.header-wrapper-bhx {
  .icon,
  .button.button--prepend-icon:before,
  .form.form--silverpop input.button--prepend-icon[type="submit"]:before {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: "icons";
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a .icon,
  a .button.button--prepend-icon:before,
  a .form.form--silverpop input.button--prepend-icon[type="submit"]:before,
  .form.form--silverpop a input.button--prepend-icon[type="submit"]:before {
    display: block;
    margin: 0 auto 10px auto;
    font-size: 32px;
  }

  .icon {
    font-family: "icons-newHeader";
  }

  .icon--airport:before {
    content: "";
  }

  .icon--angle-down:before,
  html.js .slide-panel__navigation ul.top-level > li > a.toggle:before {
    content: "";
  }

  .icon--angle-left:before,
  .picker__nav--prev:before {
    content: "";
  }

  .icon--angle-right:before,
  .picker__nav--next:before {
    content: "";
  }

  .icon--angle-up:before {
    content: "";
  }

  .icon--arrivals-departures:before {
    content: "\E006";
  }

  .icon--book-flights:before {
    content: "";
  }

  .icon--circle-o:before {
    content: "";
  }

  .icon--close:before,
  .hero-tools__content .tool .close:before {
    content: "";
  }

  .icon--destinations:before {
    content: "";
  }

  .icon--directions-transport:before {
    content: "";
  }

  .icon--facebook-square:before {
    content: "";
  }

  .icon--facebook:before,
  .button.button--facebook:before,
  .form.form--silverpop input.button--facebook[type="submit"]:before {
    content: "";
  }

  .icon--information:before {
    content: "";
  }

  .icon--navicon:before {
    content: "";
  }

  .icon--parking:before {
    content: "";
  }

  .icon--refresh:before,
  .button--refresh:before {
    content: "";
  }

  .icon--search:before,
  .slide-panel .slide-panel__search form button:before {
    content: "";
  }

  .icon--special-assistance:before {
    content: "";
  }

  .icon--twitter:before,
  .social-feed blockquote:before,
  .button.button--twitter:before,
  .form.form--silverpop input.button--twitter[type="submit"]:before {
    content: "";
  }

  .icon--warning:before {
    content: "";
  }

  .icon--calendar:before {
    content: "";
  }

  .icon--clock:before {
    content: "";
  }

  .icon--download:before,
  .cta-block.cta-block--download:after {
    content: "";
  }

  .icon--google-plus:before,
  .button.button--gplus:before,
  .form.form--silverpop input.button--gplus[type="submit"]:before {
    content: "";
  }

  .icon--youtube-play:before,
  .button.button--youtube:before,
  .form.form--silverpop input.button--youtube[type="submit"]:before {
    content: "";
  }

  .icon--bulb:before {
    content: "";
  }

  .icon--youtube:before {
    content: "";
  }

  .icon--schedule:before {
    content: "";
  }

  .icon--map-marker:before {
    content: "";
  }

  .icon--walking:before {
    content: "";
  }

  .icon--map-marker-label:before {
    content: "";
  }

  .icon--mail:before {
    content: "";
  }

  .icon--bars-restaurants:before {
    content: "";
  }

  .icon--lounges:before {
    content: "";
  }

  .icon--security-customs:before {
    content: "";
  }

  .icon--shopping:before {
    content: "";
  }

  .icon--car:before,
  .parking-content:before {
    content: "";
  }

  .icon--instagram:before,
  .button.button--instagram:before,
  .form.form--silverpop input.button--instagram[type="submit"]:before {
    content: "";
  }

  .icon--destintinations-and-more:before {
    content: "";
  }

  .icon--plane:before {
    content: "";
  }

  .icon--map-pin-car:before {
    content: "";
  }

  .icon--share:before {
    content: "";
  }

  background: rgba(14, 45, 109, 0.09);
  margin: 0;
  padding: 0;
  height: auto;
  @media screen and (max-width: 959px) {
    height: var(--header_height_mobile);
  }
  width: 100%;
  position: relative;
  box-sizing: content-box;
  .bhx-links {
    display: flex;
    text-align: center;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    a {
      padding: 0rem 1rem;
      margin: 0.75rem 0rem;
      line-height: 1.1;
      font-size: 0.825rem;
      color: #0e2d6d;
      height: 100%;
      min-height: 4.5rem;
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      text-decoration: none;
    }
  }

  .header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
  }

  .ID-logo {
    background-repeat: no-repeat;
    background-size: contain;
    width: 33%;
    height: 80px;
    max-height: var(--logo_height_desktop);
    @media screen and (max-width: 959px) {
      max-height: var(--logo_height_mobile);
      width: 66%;
    }

    margin: 4px 1rem;
    box-sizing: border-box;
    position: relative;
    background-image: var(--logo-image);
    cursor: pointer;
  }
}

.header-wrapper {
  border-bottom: var(--header_border_bottom, $header-border-bottom);
  background: var(--header_background_color, $header-background);
  margin: 0;
  padding: 0;
  height: var(--header_height_desktop, 80px);
  @media screen and (max-width: 959px) {
    height: var(--header_height_mobile);
  }

  width: 100%;
  position: relative;
  box-sizing: content-box;
  .header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
  }

  .ID-logo {
    background-repeat: no-repeat;
    background-size: contain;
    width: 33%;
    height: 100%;
    max-height: var(--logo_height_desktop);
    @media screen and (max-width: 959px) {
      max-height: var(--logo_height_mobile);
      width: 66%;
    }

    margin: 4px 1rem;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;

    .ID-logo-link {
      display: block;
      width: 100%;
      height: 100%;
    }
    .ID-logo-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: left top;
    }
  }
  .menu-items-wrapper {
    color: var(--header_font_color, $header-text-color);
    font-family: var(--header_font_family, $header-text-font);
    font-size: var(--header_font_size, 1rem);
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: auto;
    user-select: none;
    .menu-item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 0.5rem 1rem;
      border-radius: 2rem;
      // border-right: $header-btn-border;
      transition: 0.2s ease-in-out;
      margin-right: 0.5rem;

      white-space: nowrap;

      &.tab-active {
        background: var(--header_background_color_active, #034a94);
        color: var(--header_font_color_active, #034a94);
      }

      &:hover {
        background: var(--header_background_color_hover, $header-btn-hvr-bg);
        color: var(--header_font_color_hover, #034a94);
      }
      // &:first-child {
      //   border-left: $header-btn-border;
      // }
      .fa-home {
        font-size: 20px;
      }
      .lang-text {
        border-radius: 20px;
        padding: 1px 10px;
        background: $header-lang-bg;
        color: $header-lang-text;
        font-family: $header-lang-font;
      }
      .lang-flag {
        width: 32px;
        height: 32px;
      }

      .basket-icon {
        width: 37px;
        height: 38px;
        margin-left: -5px;
      }
      .basket-text {
        display: none;

        // margin-left: 10px;
        // @media screen and (max-width: 1280px) {
        //   display: none;
        // }
      }
      .basket-number {
        position: absolute;
        left: 0px;
        width: 64px;
        text-align: center;
        top: 12px;
        font-weight: bold;
        font-size: 16px;
        color: $header-basket-number;
      }
    }
    .tab-basket {
      padding-left: 10px;
      padding-right: 10px;
      margin-left: 0px;
    }
    .tab-mobile-menu {
      display: none;
    }

    .menu-items_mobile-wrapper {
      position: absolute;
      top: calc(var(--header_height_mobile) + 3px);
      right: 0px;
      display: flex;
      flex-direction: column;
      z-index: 99999;
      background: $header-mobile-bg;
      color: $header-mobile-text;
    }

    .menu-items_mobile-wrapper {
      width: 100%;
      max-width: 320px;
      box-shadow: 0 8px 8px 1px rgba(0, 0, 0, 0.5);
      .menu-item-mobile {
        box-sizing: border-box;
        padding: 15px;
        text-align: left;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      button.menu-item-mobile {
        background: none;
        border: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        font: inherit;
        color: inherit;
        cursor: pointer;
      }
      a.menu-item-mobile {
        color: inherit;
        text-decoration: none;
      }
      .menu-item-mobile.tab-lang {
        padding: 8px 15px;
        justify-content: flex-start;
        display: var(--header_show_langs, flex);
        .lang-flag {
          margin-right: 15px;
        }
      }
    }

    /* header compacting */
    @media screen and (max-width: 959px) {
      .menu-item-loop {
        display: none;
      }
      .tab-mobile-menu {
        padding: 1rem;
        display: flex;
        &:focus {
          outline: none;
        }
        &:focus-visible {
          outline: 2px solid #236ca3;
          outline-offset: 2px;
        }
      }
    }
  }
}

.menu-items-wrapper a.menu-item {
  color: inherit;
  text-decoration: none;
}

.menu-items-wrapper .menu-item.tab-home {
  @media screen and (max-width: 959px) {
    display: none;
  }
}

.menu-items-wrapper .menu-item.tab-lang {
  display: var(--header_show_langs, flex);
  @media screen and (max-width: 959px) {
    display: none;
  }
}

.menu-item-dropdown-lang {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  max-height: 40px;

  .lang-toggle {
    background: none;
    border: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
  }

  &__select {
    background: #fff;
    position: absolute;
    top: calc(100% + 0.5rem);
    z-index: 99999;
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 0.5rem;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  }
  &__select-item {
    background: none;
    border: 0;
    padding: 0;
    font: inherit;
    cursor: pointer;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    font-weight: bold;
    color: var(--header_font_color, #384048);
  }
  &__select-item:hover {
    background: var(--header_background_color_hover, #eee);
    color: var(--header_font_color_hover, #384048);
  }
}

.header-wrapper .menu-items-wrapper {
  .upsell.basket_is_model_and_page_desktop {
    @media screen and (max-width: 1099.98px) {
      display: none;
    }
  }

  .upsell.basket_is_model_and_page_mobile {
    @media screen and (min-width: 1100px) {
      display: none;
    }
  }
}

.ID-logo-BH1.ID-logo-BH1.ID-logo-BH1 {
  @media screen and (min-width: 959px) {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }
}
.header-wrapper-bhx.header-wrapper-bhx {
  @media screen and (max-width: 959.98px) {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }
}

.bhx-search {
  border-left: 1px solid #0e2d6d;
}

.header-wrapper-hello-msg.header-wrapper-hello-msg {
  height: auto;
  background: #ffa500;

  .header-inner {
    width: 100%;
    margin: 0 auto;
    padding: 1rem;
    text-align: center;
    display: block;
  }

  .hello-msg {
    display: block;
    text-align: center;
    width: 100%;
    margin: 0 auto;
    font-weight: bold;
    //color: #fff;

    a {
      font-weight: bold;
      //color: #fff;
      text-decoration: underline;
    }
  }
}

.header-wrapper.header-wrapper-hello-msg.header-wrapper-hello-msg.header-wrapper-hello-msg-rdu {
  background: #00549f;
  span.hello-msg {
    color: #fff !important;
  }
}

.header-wrapper.header-wrapper-hello-msg.header-wrapper-hello-msg.header-wrapper-hello-msg-all {
  background-color: var(--footer_top_background_color, #384048);
  strong.hello-msg {
    color: var(--footer_top_text_color, #fff) !important;
  }
}

.header-wrapper.mapsearch {
  .header-inner {
    max-width: 100%;
  }
}

.hide-hello-msg.header-wrapper-hello-msg {
  display: none !important;
}

.header-message-wrapper {
  border-bottom: var(--header_border_bottom, 3px solid #034a94);
  background: var(--header_background_color, #fff);
  margin: 0;
  padding: 0;
  width: 100%;
  position: relative;
  box-sizing: content-box;
  margin-top: -3px;
  /* soft shadow on inside top edge */
  box-shadow: inset 0 8px 8px -8px #000;

  .header-message-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    max-width: calc(1280px + 2rem);
    margin: 0 auto;
    padding: 1rem;
  }

  .header-message-button {
    background: #fff;
    border: 1px solid currentColor;
    color: currentColor;
    font-weight: bold;
    min-height: 2rem;
    min-width: 5rem;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease,
      box-shadow 0.15s ease;

    &:hover {
      background: #f1f6ff;
      box-shadow: 0 2px 6px rgba(44, 79, 141, 0.2);
    }

    &:active {
      background: #e5efff;
      color: currentColor;
    }
  }

  .header-message-close {
    margin-left: 0.5rem;
    border: 0;
    background: transparent;
    color: currentColor;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    line-height: 1;

    &:hover {
      opacity: 0.75;
    }
  }

  .header-message-info-icon {
    margin-right: 0.35rem;
    font-size: 1rem;
    color: currentColor;
  }

  .header-message-info-icon--information {
    color: #1120f4;
  }

  .header-message-info-icon--alert {
    color: #e30613;
  }

  .header-message-info-icon--weather_warning {
    color: #ff9800;
  }
}
</style>
